import '@babel/polyfill'
import { Vue } from "vue-property-decorator";
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import VueRouter from 'vue-router';
import App from './App.vue'
import * as Sentry from "@sentry/vue";
import Cart from "@/views/Cart.vue";
import Checkout from "@/views/Checkout.vue";
import {Transaction} from "@sentry/browser";

declare global {
    interface Window {
        defaultCheckoutCountry: string|undefined;
        factories: {
            createConfig: (data: any) => any;
            createStore: (config: any) => Promise<any>;
            createManager: (store: any) => any;
            createRenderer: (store: any, type?: string) => any;
        };
        amazon: {
            Pay: {
                initCheckout(config: object): void;
            }
        };
        env?: {
            sentryDsn?: string,
            environment?: string,
        },
        pageLoadTransaction?: Transaction;
    }
}

if (window.env && window.env.sentryDsn && window.env.environment) {
    Sentry.init({
        Vue,
        dsn: window.env.sentryDsn,
        environment: window.env.environment,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.0,
        integrations: [
            new Sentry.Replay(
                {
                    maskAllText: window.env.environment === 'production',
                    blockAllMedia: window.env.environment === 'production',
                    networkDetailAllowUrls: [window.location.origin],
                    networkCaptureBodies: true,
                }
            ),
            new Sentry.BrowserTracing({
                traceXHR: true,
                traceFetch: true,
            }),
        ],
        tracePropagationTargets: [window.location.origin]
    });

    const traceElement = document.querySelector('meta[name=sentry-trace]');
    const baggageElement = document.querySelector('meta[name=baggage]');
    if (traceElement !== null && baggageElement !== null) {
        const sentryTrace = (<HTMLMetaElement>traceElement).content;
        const baggage = (<HTMLMetaElement>baggageElement).content;

        window.pageLoadTransaction = Sentry.continueTrace(
            { sentryTrace, baggage },
            (transactionContext) => {
                return Sentry.startTransaction({
                    ...transactionContext,
                    name: `Pageload: ${window.location.pathname}`,
                    op: 'pageload',
                });
            }
        );
    }
}

const langCartMapper: {[lang: string]: string} = {
    de: 'warenkorb',
    at: 'warenkorb',
    ch: 'warenkorb',
    en: 'cart',
    eu: 'cart',
    it: 'cart',
    fr: 'panier',
    nl: 'cart',
    be: 'cart',
}

const routes = [
    {path: `/${lang}/${langCartMapper[lang]}/:personalizedCartId?`, component: Cart, name: 'cart'},
    {path: `/${lang}/checkout`, component: Checkout, name: `checkout`}
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

Vue.use(VueRouter);
Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover);

document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('#checkout2');

    const checkoutData = el!.getAttribute('data-checkout');
    const countries = el!.getAttribute('data-countries');
    const payments = el!.getAttribute('data-payments');

    new Vue({
        render: h => h(App, {
            props: {
                checkoutData: checkoutData !== null ? JSON.parse(checkoutData) : null,
                countries: countries !== null ? JSON.parse(countries) : null,
                payments: payments !== null ? JSON.parse(payments) : null,
            },
        }),
        router,
    }).$mount('#checkout2');
});
